import React from 'react';

function SevicesTwoCard({ thumbnail, icon, heading, text }) {
    return (
        <div className="col-md-6 col-xl-4 col-12">
            <div className="single-service-card">
                <div
                    className="card-thumb bg-cover"
                    style={{
                        backgroundImage: `url(${thumbnail})`,
                    }}
                />
                <div className="content">
                    <div className="case-cat">
                        <span>{icon}</span>
                    </div>
                    <h3>{heading}</h3>
                    <p>{text}</p>
                </div>
            </div>
        </div>
    );
}

export default SevicesTwoCard;
